import EntityModel from '@/common/models/entity-model';

export default class EmailAttachmentModel extends EntityModel {
    hydrate({
        resourceType = null,
        resourceId = null,
    } = {}) {
        this.resourceType = resourceType;
        this.resourceId = resourceId;
    }

    getPayload() {
        return {
            resourceType: this.resourceType,
            resourceId: this.resourceId,
        };
    }
}
